"use strict";exports.__esModule=true;exports.default=_default;function _default(R){var UNDEF,M="M",A="A";R.define&&R.define([{name:"arcpath",arcpath:function arcpath(){return this.path(UNDEF,R._lastArgIfGroup(arguments))},ca:function ca(x,y,r1,r2){var d=r2,path,dr=d-90,radians=Math.PI*(dr/180),endx=x+r1*Math.cos(radians),endy=y+r1*Math.sin(radians),largeArc=d>180?1:0;path=[M,x,y-r1,A,r1,r1,0,largeArc,1,endx,endy];return{path:path}}}])}


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/_internal/redraphael/redraphael-shapes/redraphael-shapes.arcpath.js
// module id = sysG
// module chunks = 5